<template>
    <div class="home-page-container" style="background-color: #fff;height: 100%;">
        <fee-card title="待交费用" :listArr="unpaidFeeList" style="min-height: 30%"></fee-card>
        <fee-card title="选交费用" :listArr="chooseFeeList" style="min-height: 40%"></fee-card>
        <fee-card title="个人服务" :listArr="personalServiceList"></fee-card>
    </div>
</template>

<script>
    import log from "utils/log"
    import utils from '@/utils/util'
    import feeCard from "components/fee-card/index"
    import apiChooseFee from "api/choose-fee"
    // import {getState, setState} from "utils/state";
    import storage from 'good-storage'


    export default {
        name: "HomePage",
        components: {
            feeCard,
        },
        data() {
            return {
                unpaidFeeList: [
                    {
                        name: '学杂费',
                        router: 'unpaid-fee',
                        src: 'unpaid-fee',
                        param: {code: 'XZF'}
                    }, 
                    {
                        name: '辅修费',
                        router: 'unpaid-fee',
                        src: 'pay-fxf',
                        param: {code: 'FXF'}
                    },
                    {
                        name: '培训费',
                        router: 'unpaid-fee',
                        src: 'pay-pxf',
                        param: {code: 'PXF'}
                    },
                    {
                        name: '考试费',
                        router: 'unpaid-fee',
                        src: 'pay-ksf',
                        param: {code: 'KSF'}
                    },
                    {
                        name: '其他待交费用',
                        router: 'unpaid-fee',
                        src: 'pay-more',
                        param: {code: 'QTYSF'}
                    }
                ],
                chooseFeeList: [
                    {
                        name: '网费',
                        router: 'https://cas.sysu.edu.cn/cas/login?service=https://netpay.sysu.edu.cn/netpay/workwx',
                        src: 'pay-net',
                        type:'external'
                    },
                    {
                        name: '教职工零星退款',
                        router: 'choose-fee-detail',
                        src: 'pay-jzglxtf',
                        style: 'font-size:13px;',
                        param: {code: '81100165'},
                        needCheck:true,
                        show:false
                    }
                    // {
                    //     name: '即将开放',
                    //     router: '',
                    //     src: '',
                    // }
                    // {
                    //     name: '水电预付费',
                    //     router: 'https://sdwpay.sysu.edu.cn/wx/wechat/index.jsp',
                    //     src: 'pay-sdf',
                    //     type:'external',
                    // },
                    // {
                    //     name: '即将开放',
                    //     router: '',
                    //     src: '',
                    // }
                ],
                personalServiceList: [
                    {
                        name: '交费记录',
                        router: 'pay-situation',
                        src: 'pay-situation'
                    },
                    /* {
                         name: '退费记录',
                         router: 'pay-refund',
                         src: 'pay-refund',
                     },*/
                    {
                        name: '付款记录',
                        router: 'pay-record',
                        src: 'pay-record'
                    },
                ]
            }
        },
        mounted() {
            if(window.history && window.history.pushState){
                window.addEventListener('popstate',this.backChange,false)
            }
        },
        created() {
            //alert(document.URL)
            //history.pushState(null, null, document.URL); 
            if(utils.isWxWorkBrowser()){
                history.pushState(null, null, document.URL);
            } 
            this.handleChooseFeeList();
        },
        methods: {
            backChange(){
                //alert(window.location.href);
                if (window.location.href.endsWith('/home')) {
                    if(utils.isWxWorkBrowser()){
                        history.pushState(null, null, document.URL);
                    }                  
                }
                if(window.location.href.indexOf('commsso')>-1){
                    let commssoUrl = process.env.VUE_APP_FIS_COMMSSO_URL;
                    window.location.href = commssoUrl;
                }
            },
            getChooseFeeList() {
                // apiChooseFee.list().then(res => {
                //     let d = res.data || []
                //     if (d.length > 5) {
                //         let t = d.slice(0, 4)
                //         let t2 = this.generateList(t)
                //         let t3 = [
                //             {
                //                 name: '查看全部',
                //                 router: 'choose-fee',
                //                 icon: 'more',
                //             }
                //         ]
                //         this.chooseFeeList = [...t2, ...t3]
                //     } else {
                //         this.chooseFeeList = this.generateList(d)
                //     }
                // })
            },

            generateList(item) {
                let that = this
                return item.map(t => {
                    return {
                        name: t.itemName,
                        data: t,
                        onClick: (item) => that.clickItem(item)
                    }
                })
            },

            handleChooseFeeList(){
                let tmp = [];
                this.chooseFeeList.forEach(item => {
                    if(item.needCheck){
                        apiChooseFee.checkEnabled(item.param).then(res=>{
                            if(res.data){
                                //console.log("data",res.data);
                                item.show = true;
                            }else{
                                item.show = false;
                            }
                        })
                    }
                });
            },

            clickItem(item) {
                log('item', item)
                // setState('select-item', item.data)
                storage.session.set('select-item', item.data)
                this.$router.push({
                    name: 'choose-fee-detail',
                })
            }

        }

    }
</script>

<style scoped>
</style>
